function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from '../../../../Button';
import { SIZES } from '../../../constants';
import styles from '@dtsl/css-input/dist/index.module.css';
import { SimpleSelect } from '@dtsl/react/dist/components/SimpleSelect';

// eslint-disable-next-line react/display-name
const Addon = /*#__PURE__*/React.memo(props => {
  const {
    isLeft,
    addOn,
    size,
    disabled
  } = props;
  const addOnClasses = classNames({
    [styles['sib-input__addon']]: true,
    [styles[`sib-input__addon--${size}`]]: size === SIZES.SMALL,
    [styles['sib-input__addon-left']]: isLeft,
    [styles['sib-input__addon-right']]: !isLeft,
    [styles['sib-input__addon--iconAlone']]: addOn?.simpleSelectData?.triggerMetaData?.iconAlone,
    [addOn?.className]: !!addOn?.className,
    [styles['sib-simple-select--trigger-left']]: addOn?.simpleSelectData && isLeft,
    [styles['sib-simple-select--trigger-right']]: addOn?.simpleSelectData && !isLeft
  });
  const simpleSelectData = addOn?.simpleSelectData;
  if (simpleSelectData) {
    const {
      id,
      isOpen,
      options,
      onSelect,
      searchable,
      searchableProps,
      noOptionContent,
      triggerMetaData,
      selectedValue,
      menuStyles,
      menuClassName,
      className
    } = simpleSelectData;
    const _triggerMetaData = {
      ...triggerMetaData,
      disabled,
      size,
      className: addOnClasses,
      variant: 'tertiary'
    };
    return /*#__PURE__*/React.createElement(SimpleSelect, {
      className: className,
      isOpen: isOpen,
      id: id
    }, /*#__PURE__*/React.createElement(SimpleSelect.Trigger, null, (isMenuOpen, setIsMenuOpen) => {
      return /*#__PURE__*/React.createElement(Button, _extends({
        showArrowIcon: true
      }, _triggerMetaData, {
        onClick: e => {
          e.preventDefault();
          setIsMenuOpen(open => !open);
          triggerMetaData?.onClick?.(e, isMenuOpen, setIsMenuOpen);
        },
        dropdownOpen: isMenuOpen,
        variant: "tertiary"
      }));
    }), /*#__PURE__*/React.createElement(SimpleSelect.Menu, {
      style: menuStyles,
      searchable: searchable,
      className: menuClassName,
      noOptionContent: noOptionContent,
      searchableProps: searchableProps
    }, Array.isArray(options) && options?.map(option => {
      const {
        id,
        label,
        value
      } = option;
      return /*#__PURE__*/React.createElement(SimpleSelect.Option, {
        key: id || label || value,
        option: option,
        selectedValue: selectedValue,
        onSelect: onSelect
      });
    })));
  }
  return addOn ? /*#__PURE__*/React.createElement(Button, _extends({
    disabled: disabled
  }, addOn, {
    variant: "tertiary",
    className: addOnClasses,
    size: size
  })) : null;
});
Addon.propTypes = {
  isLeft: PropTypes.bool,
  addOn: PropTypes.object,
  size: PropTypes.string,
  disabled: PropTypes.bool
};
export default Addon;